import axios from "./../../config/axios";

function isLocked(date) {
    return axios().get(`/sales-scheduling/locked-dates/${date}/is-locked`);
}

function lock(date) {
    return axios().get(`/sales-scheduling/locked-dates/${date}/lock`);
}

function unlock(date) {
    return axios().get(`/sales-scheduling/locked-dates/${date}/unlock`);
}


export default {
    isLocked,
    lock,
    unlock
}